var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSphere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000",
    height: 800,
    width: 800,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 0C114.837 0 0 114.837 0 256s114.837 256 256 256 256-114.837 256-256S397.163 0 256 0zm0 21.333c129.387 0 234.667 105.28 234.667 234.667 0 40.363-96.384 85.333-234.667 85.333-28.629 0-55.339-2.005-79.893-5.44-3.435-24.555-5.44-51.264-5.44-79.893 0-138.283 44.97-234.667 85.333-234.667zm-47.488 4.843C173.184 67.435 149.333 153.707 149.333 256c0 26.688 1.621 52.309 4.651 76.309C72.683 317.205 21.333 285.419 21.333 256c0-113.131 80.491-207.808 187.179-229.824zM26.176 303.488c27.072 23.168 73.429 41.429 131.136 51.2 9.792 57.707 28.032 104.064 51.2 131.136-91.349-18.859-163.477-90.987-182.336-182.336zM256 490.667c-29.419 0-61.205-51.349-76.309-132.651 24 3.029 49.621 4.651 76.309 4.651 102.293 0 188.565-23.851 229.824-59.179C463.808 410.176 369.131 490.667 256 490.667z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSphere);
export default __webpack_public_path__ + "static/media/sphere.a6b9f09cb2f3fc90a2fbb53e761b43b7.svg";
export { ForwardRef as ReactComponent };